<template>
	<div class="pages">
		<section class="radio-material">
			<div class="module">
				<div class="p-b-15 radio-content">
					<z-radio-bar :list-obj="radioBarParams.list" :active="radioBarParams.active" @handleClickRadioBar="handleClickRadioBar"></z-radio-bar>
				</div>
				<div class="reply-text" v-if="radioBarParams.active=='text'">
					<textarea class="edit" v-model="textContent" placeholder="请输入回复内容..."></textarea>
				</div>
				<div class="reply-news" v-if="radioBarParams.active=='news'">
					<div class="reply" v-if="radioBarParams.list[1].content">
						<ul>
							<li v-for="item in radioBarParams.list[1].content.newsItem || []">
								<div class="item fx">
									<h6 class="fx-fill">{{item.title}}</h6>
									<p class="pic fx-shrink"><img :src="item.picurl | showWxImages" /></p>
								</div>
								<p v-show = "item.description">{{item.description}}</p>
							</li>
						</ul>
						<p class="del-btn">
							<a @click="handleDelContent">删除</a>
						</p>
					</div>
					<div class="fx" v-show="!radioBarParams.list[1].content">
						<div class="fx" v-show="!isCustomNews">
							<div class="add-material"  @click="showLayers">
								<p class="icon-add"></p>
								<h5>从图文素材库选择</h5>
							</div>
							<div class="add-material m-l-10" v-show="!radioBarParams.list[1].content" @click="handleIsShowCustomNews(true)">
								<p class="icon-add"></p>
								<h5>跳转外部链接图文</h5>
							</div>
						</div>
						
						<div class="fx link-cont" v-show="isCustomNews">
							<div class="thumbnail-grp">
								<ul>
									<li v-for="item in newsObj.newsItem || []">
										<div class="thumbnail">
											<h6>{{item.title || '标题...'}}</h6>
											<div class="pic-cont"><img :src="item.picurl | showWxImages" /></div>
										</div>
										<p class="describe">{{item.description || '摘要...'}}</p>
									</li>
								</ul>
							</div>
							<div class="edit-cont p-l-10">
								<p><a class="z-btn c-m b-r-3" @click="handleShowImageLayer">{{newsObj.newsItem[0].picurl ? "重新选择封面":"选择封面素材"}}</a><span class="c-g m-l-10">封面建议尺寸：900 x 500</span></p>
								<p><input type="text" class="input" placeholder="请输入标题" maxlength="50" v-model ="newsObj.newsItem[0].title"/></p>
								<p><input type="text" class="input" placeholder="请输入摘要" maxlength="50" v-model ="newsObj.newsItem[0].description" /></p>
								<p><input type="text" class="input" placeholder="请输入点击跳转的URL地址,如：http://xxx.com" maxlength="200" v-model ="newsObj.newsItem[0].url" /></p>
								<p class="m-t-15">
									<a class="z-btn c-m b-r-3" @click="handleSaveCustomNews">确定</a>
									<a class="z-btn z-btn-default b-r-3 m-l-15" @click="handleIsShowCustomNews(false)">返回</a>
								</p>
							</div>
						</div>
					</div>
					
				</div>
				<div class="reply-image" v-if="radioBarParams.active=='image'">
					<div class="reply" v-if="radioBarParams.list[2].content">
						<p class="pic"><img width="100%" :src="radioBarParams.list[2].content.content.url | showWxImages" /> </p>
						<p class="del-btn">
							<a @click="handleDelContent">删除</a>
						</p>
					</div>
					<div class="add-material" v-show="!radioBarParams.list[2].content" @click="showLayers">
						<p class="icon-add"></p>
						<h5>从图片素材库选择</h5>
					</div>
				</div>
				<div class=" reply-voice" v-if="radioBarParams.active=='voice'">
					<div class="reply" v-if="radioBarParams.list[3].content">
						<div class="voice">
							<h6>{{radioBarParams.list[3].content.content.name}}</h6>
							<p class="icon-voice"> </p>
						</div>
						<p class="del-btn">
							<a @click="handleDelContent">删除</a>
						</p>
					</div>
					<div class="add-material" v-show="!radioBarParams.list[3].content" @click="showLayers">
						<p class="icon-add"></p>
						<h5>从语音素材库选择</h5>
					</div>
				</div>
				<div class="reply-video" v-if="radioBarParams.active=='video'">
					<div class="reply" v-if="radioBarParams.list[4].content">
						<div class="video">
							<h6>{{radioBarParams.list[4].content.content.title}}</h6>
							<p class="icon-video"> </p>
						</div>
						<p class="del-btn">
							<a @click="handleDelContent">删除</a>
						</p>
					</div>
					<div class="add-material" v-show="!radioBarParams.list[4].content" @click="showLayers">
						<p class="icon-add"></p>
						<h5>从视频素材库选择</h5>
					</div>
				</div>
			</div>
		</section>
		<z-layers-material 
			:is-show="isLayerMaterial" 
			:title="'素材管理'" 
			@handleOk="getMaterial" 
			@handleCancel="handleCancel">
			<z-material 
				:is-get-material="isLayerMaterial" 
				:is-tab-bar="isMaterialTabBar" 
				:type="radioBarParams.active" 
				@handleSelectMaterial="handleSelectMaterial
	  			">
			</z-material>
		</z-layers-material>
		<!--只选择图片-->
		<z-layers-material 
			:is-show="isLayerImage" 
			:title="'素材管理'" 
			@handleOk="getImage" 
			@handleCancel="handleCancelImage">
			<z-material 
				:is-get-material="isLayerImage" 
				:is-tab-bar="isMaterialTabBar" 
				:type="'image'" 
				@handleSelectMaterial="handleSelectImage
	  			">
			</z-material>
		</z-layers-material>
	</div>
</template>
<script>
	export default {
		name: 'z-radio-material',
		components: {
		},
		/*
		 * 接收父组件数据
		 */
		data() {
			return {
				selectedContent: null, //选中的素材
				isMaterialTabBar: false, //是否显示素材管理里面的tabbar
				isCustomNews:false,//是否是自定义素材
				isLayerImage:false,//是否显示图片素材弹出层
				picurl:null,//图片地址
				newsObj:{//自定义图文素材
					newsItem: [{
		             "title":null,
		             "description":null,
		             "url":null,
		             "picurl":null
		       		}]
				}
			}
		},
		props: {
			isLayerMaterial:{//是否显示素材弹出层
				type: Boolean,
				default: false
			},
			radioBarParams: {//单选素材内容对象
				type: Object,
				default: {}
			}
		},
		watch :{
	  	},
		/*
		 * 实例计算属性
		 */
		computed: {
			textContent:{
				get() {
					return this.radioBarParams.list[0].content.content
				},
				set(value) {
					let content = {
						type:'text',
						content:value
					}
					this.$emit('handleSetContent',content,'text')
				}
			},
		},
		/*
		 * 处理事件
		 */
		methods: {
			handleIsShowCustomNews(type){
				this.isCustomNews = type
			},
			handleShowImageLayer(){//显示图片素材弹层
				this.isLayerImage = true
			},
			getImage(){//获取图片地址
				this.isLayerImage = false
				this.newsObj.newsItem[0].picurl = this.picurl
			},
			handleCancelImage(){//取消图片素材弹层
				this.isLayerImage = false
			},
			handleSelectImage(item){//选取图片素材
				this.picurl = item ? item.url : null
			},
			handleClickRadioBar(type) { //radioBar切换
				this.$emit('handleClickRadioBar',type)
			},
			showLayers() { //显示隐藏弹出层
				this.$emit('cancelMaterialLayer')
			},
			handleCancel() {//取消选中素材
				this.selectedContent = null
				this.showLayers()
			},
			handleSelectMaterial(item) { //选中素材
				this.selectedContent = item
			},
			handleDelContent() { //删除选中素材
				this.$confirm(`确定要删除此素材?`).then(action => {
					this.$emit('handleSetContent',null,this.radioBarParams.active)
				},()=>{});
				
			},
			handleSaveCustomNews(){//保存自定义图文
				if(!this.picurl){
					return this.$warning('请选择素材')
				}
				if(!this.newsObj.newsItem[0].title){
					return this.$warning('请输入标题')
				}
				if(!this.$re_Url(this.newsObj.newsItem[0].url)){
					return this.$warning('请输入跳转的url链接')
				}
				this.isCustomNews = false
				this.$emit('handleSetContent',this.newsObj,this.radioBarParams.active)
			},
			getMaterial() { //显示选中素材
				this.showLayers()
				let content = null
				switch(this.radioBarParams.active) {
					case 'news':
						let newsItem = this.selectedContent.content.news_item
						content = {
							mediaId:this.selectedContent.media_id,
							newsItem : newsItem.map((item, index) => {
								let d = {}
								d.title = item.title
								d.description = item.digest
								d.picurl = item.thumb_url
								d.url = item.url
								return d
							}) || []
						}
						
						break;
					case 'image':
						content = {
							type: "image",
							content: {
								mediaId: this.selectedContent.media_id,
								url: this.selectedContent.url
							}
						} || {}
						break;
					case 'voice':
						content = {
							type: "voice",
							content: {
								mediaId: this.selectedContent.media_id,
								name: this.selectedContent.name
							}
						} || {}

						break;
					case 'video':
						content = {
							type: "video",
							content: {
								mediaId: this.selectedContent.media_id,
								title: this.selectedContent.name,
								description: this.selectedContent.name
							}
						} || {}

						break;
					default:
						content = null
						break;
				}
				
				this.$emit('handleSetContent',content,this.radioBarParams.active)
			}
			
		},
		deactivated (){//页面切换出去
	  		this.isCustomNews = false
	  		this.picurl = null
	  		for(let key in this.newsObj.newsItem[0]){
	  			this.newsObj.newsItem[0][key] = null
	  		}
	    }
	}
</script>
<!-- 添加 scoped “范围”属性CSS限制这个组件只 -->
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.reply-text{
		width: px-em(600px);
		textarea{
			min-height:px-em(150px);
		}
	}
	.reply{
		width: px-em(400px);
		position: relative;
		.del-btn{
			position: absolute;
			left: 100%;
			bottom: 0;
			width: 60px;
			margin-left: 10px;
			a{
				color: $color-btn;
			}
		}
	}
	.reply-news{
		ul{
			display: block;
			border: $color-border 1px solid;
			
		}
		li{
			border-bottom: $color-border 1px solid;
			padding: px-em(20px);
			.item{
				position: relative;
				.pic{
					width: 50px;
					height: 50px;
					img{
						width: 100%;
						height: 100%;
					}
				}
			}
			&:first-child{
				.pic{
					width: 100%;
					height: px-em(200px);
				}
				h6{
					position: absolute;
					width: 100%;
					left: 0;
					bottom: 0;
					background: rgba(0,0,0,0.5);
					color: $color-white;
					padding: 5px 10px;
				}
			}
			&:last-child{
				border-bottom: none;
			}
		}
		
	}
	.reply{
		.voice,.video{
			position: relative;
			border: $color-border 1px solid;
			h6{
				position: absolute;
				width: 100%;
				left: 0;
				bottom: 0;
				background: rgba(0,0,0,0.5);
				color: $color-white;
				padding: 5px 10px;
			}
			p{
				padding: 20px 0 40px;
				color:  $color-btn;	
				font-size: px-em(100px);
				text-align: center;
			}
		}
	}
	.add-material{
		width: px-em(400px);
		text-align: center;
		border: dashed 1px $color-border;
		padding: px-em(30px);
		color: $color-gray;
		.icon{
			padding-bottom: 5px;
			color: $color-gray;
			font-size: px-em(40px);
		}
		&:hover{
			color: $color-btn;
			border-color: $color-btn;
			cursor: pointer;
			.icon{
				color: $color-btn;
			}
		}
		
	}
	.link-cont{
		.thumbnail-grp{
			.thumbnail{
				width: 260px;
				height: 160px;
				position: relative;
				overflow: hidden;
				h6{
					position: absolute;
					bottom: 0;
					left: 0;
					right: 0;
					z-index: 99;
					width: 100%;
					background: rgba(0,0,0,.5);
					padding: 5px 10px;
				}
				img{
					height: 100%;
					width: 100%;
				}
			}
			.describe{
				width: 260px;
			}
		}
		.edit-cont{
			.c-g{
				color: $color-7a7a7a;
			}
			.c-m{
				color: #fff;
				background: $color-main;
				&:active{
					background: darken($color-main,10%);
					opacity: 1;
				}
			}
			input{
				width: 350px;
				margin-top: 10px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// RadioMaterial.vue?351a40fe